import { FormControl, Validators } from '@angular/forms';
import { AutomaticDiscountGetDto } from 'app/shared/models/automatic-discount.models';
import { MediaDTO } from 'app/shared/models/media.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { distinctUntilChanged } from 'rxjs/operators';

import { ShopFilterItem } from './filter-item.model';
import { ProductPricesSummary } from './product-card.model';
import { SizeGroupTypeEnum } from 'app/back-office/shared/enum/size-group-type.enum.model';
import { VariantsGridDataInputModel } from './variants-grid-data-input.model';
import { ElaboratedCustomDates } from './product-variant';

export class ProductOrderItemNew {
  // palettes?: Array<ProductPalette>;
  imageUrl: string;
  quantityBuyIncrement?: number;
  requestedDeliveryDate?: string;
  storeChannelDiscount?: number;
  variantsGridDataInputModel?: VariantsGridDataInputModel;
  constructor(s?: Partial<ProductOrderItemNew>) {
    if (s) {
      Object.assign(this, s);
    }
  }

}
export class ProductOrderNew {
  imageUrl: string;
  productName: string;
  productCode: string;
  productId: number;
  dates: ProductOrderItemNew[];

  constructor(s?: Partial<ProductOrderNew>) {
    if (s) {
      Object.assign(this, s);
    }
  }

  get totalPrice() {
    let price = 0;
    // this.dates.forEach(d => d.palettes?.forEach(x => x.sizes.forEach(s => price += ((s.discountedUnitPrice || 0) * (s.value?.value || 0)))));
    this.dates.forEach(d => d.variantsGridDataInputModel.cartMode.variants?.forEach(x => price += (x.discountedUnitPrice || 0) * (x.quantity || 0)));
    return price;
  }

  get totalDiscountedAmount() {

    return this.getTotalUnitPrice() - this.totalPrice;
  }

  get totalDiscountPercentage() {
    return Number(((((this.totalPrice + this.totalDiscountedAmount) - this.totalPrice) * 100) / (this.totalPrice + this.totalDiscountedAmount)).toFixed(0));
  }

  private getTotalUnitPrice() {
    let unitPrice = 0;
    this.dates.forEach(d => d.variantsGridDataInputModel?.cartMode?.variants?.forEach(x => {
      unitPrice += x?.unitPriceWholesale * (x?.quantity || 0);
    }));
    return unitPrice;
  }

  get totalQuantity() {
    let quantity = 0;
    this.dates.forEach(d => d.variantsGridDataInputModel?.cartMode?.variants?.forEach(x => quantity += +x.quantity || 0));
    return quantity;
  }

  get totalRetailPrice() {
    var total = 0;
    this.dates.forEach(d => d.variantsGridDataInputModel?.cartMode?.variants?.forEach(p => total += ((p.unitRetailPrice || 0) * (p.quantity || 0))));
    return total;
  }
  get totalWholeSalePrice() {
    var total = 0;
    this.dates.forEach(d => d.variantsGridDataInputModel?.cartMode?.variants?.forEach(p => total += (p.unitPriceWholesale || 0) * (p.quantity || 0)));
    return total;
  }

  get countOfUnavailable() {
    let result = 0;
    this.dates.forEach(d => {
      result = result + d.variantsGridDataInputModel?.cartMode?.variants?.filter(s => !s.isWhiteCell && s.availableQuantity < s.quantity).length;
    })
    return result;
  }
}

export class ProductOrder {
  productName: string;
  productCode: string;
  productId: number;
  sizeGroupId: number;
  sizeGroupName: string;
  palettes: Array<ProductPalette>;
  quantityBuyIncrement: number;
  requestedDeliveryDate?: string;
  customDeliveryDate?: ElaboratedCustomDates;
  storeChannelDiscount: number;
  checked?: boolean;
  variantsGridDataInputModel: VariantsGridDataInputModel;

  constructor(s: Partial<ProductOrder>) {
    if (s) {
      Object.assign(this, s);
    }

    if (s.palettes) {
      this.palettes = s.palettes.map(x => new ProductPalette(x));
    }
  }

  get sizesRange() {
    const sizesRange: ShopFilterItem[] = [];
    this.palettes.forEach(x => {
      x.sizes.forEach(y => {
        if (!sizesRange.find(s => s.id === y.id)) {
          sizesRange.push(y);
        }
      });
    });
    return sizesRange.sort((a, b) => Number(a.name) - Number(b.name));
  }

  get totalPrice() {
    let price = 0;
    this.palettes?.forEach(x => x.sizes.forEach(s => price += ((s.discountedUnitPrice || 0) * (s.value?.value || 0))));
    return price;
  }

  get totalDiscountedAmount() {

    return this.getTotalUnitPrice() - this.totalPrice;
  }

  get totalDiscountPercentage() {
    return Number(((((this.totalPrice + this.totalDiscountedAmount) - this.totalPrice) * 100) / (this.totalPrice + this.totalDiscountedAmount)).toFixed(0));
  }

  private getTotalUnitPrice() {
    let unitPrice = 0;
    this.palettes?.forEach(x => {
      x.sizes.forEach(y => unitPrice += y?.unitPriceWholesale * y?.value.value || 0);
    });
    return unitPrice;
  }

  get totalQuantity() {
    let quantity = 0;
    this.palettes?.forEach(x => quantity += +x.totalPcs || 0);
    return quantity;
  }

  get countOfUnavailable() {
    return this.palettes.map(x => x.sizes.filter(s => !s.isWhiteCell && s.availableQuantity < s.quantity).length).reduce((prev, curr) => prev + curr);
  }


  get totalRetailPrice() {
    var total = 0;
    this.palettes?.forEach(p => p.sizes.forEach(s => total += ((s.retailUnitPrice || 0) * (s.value?.value || 0))));
    return total;
  }
  get totalWholeSalePrice() {
    var total = 0;
    this.palettes?.forEach(p => p.sizes.forEach(s => total += ((s.unitPriceWholesale || 0) * (s.value?.value || 0))));
    return total;
  }
}

export class ProductSizeGroup {
  sizeGroupId: number;
  sizeGroupName: string;
  quantityBuyIncrement: number;
  quantityMinimumPerOrder: number;
  palettes: Array<ProductPalette>;
  isProductAvailable: boolean;
  _buffer: ProductPalette;
  isGroupEmpty: boolean;
  constructor(s: Partial<ProductSizeGroup>) {
    if (s) {
      Object.assign(this, s);

      if (s.palettes) {
        this.palettes = s.palettes.map(x => new ProductPalette(x));
      }
      this.isGroupEmpty = !(this.palettes?.length > 0);
    }
  }

  clearSizeGroupPcs() {
    this.palettes?.forEach(x => x.clearPalettePcs());
  }

  get isCanCopy() {
    return this._buffer ? this._buffer.sizes.some(x => x.value.value > 0) : false;
  }

  get sizesRange() {
    const sizesRange: ShopFilterItem[] = [];
    this.palettes.forEach(x => {
      x.sizes.forEach(y => {
        if (!sizesRange.find(s => s.id === y.id)) {
          sizesRange.push(y);
        }
      });
    });
    return sizesRange.sort((a, b) => Number(a.name) - Number(b.name));
  }

  get isAvailablePalettes() {
    return this.palettes.some(x => x.isAvailableSizes);
  }

  copyPaletteSizes(paletteId: number) {
    const palette = this.palettes?.find(x => x.paletteId === paletteId);
    this._buffer = new ProductPalette({ ...palette });
  }

  pastePaletteSizes(paletteId: number) {
    const palette = this.palettes?.find(x => x.paletteId === paletteId);
    palette?.sizes?.forEach(x => this._buffer.sizes.filter(y => x.id === y.id).forEach(y => x.value.setValue(y.value.value)));
  }
}

export class ProductPalette {
  code: string;
  paletteId: number;
  palletName: string;
  label: string;
  media: MediaDTO[];
  wholesalePrice?: string;
  retailPrice?: string;
  priceDetails?: ProductPricesSummary;
  sizes?: Array<ProductSize>;
  stockLimit?: number;
  quantityBuyIncrement: number;
  quantityMinimumPerOrder: number;
  constructor(s: Partial<ProductPalette>) {
    if (s) {
      Object.assign(this, s);

      if (s.sizes) {
        this.sizes = s.sizes.map(x => new ProductSize(x)).sort((a, b) => Number(a.name) - Number(b.name));
      }
    }
  }

  get totalPcs() {
    return (this.sizes || []).reduce((sum, x) => sum += +x.value.value, 0);
  }

  clearPalettePcs() {
    this.sizes?.forEach(x => x.clear());
  }

  get totalPrice() {
    let price = 0;
    this.sizes?.forEach(x => price += x.totalPrice || 0);
    return price;
  }

  get isAvailableSizes() {
    return this.sizes.some(x => x.availableQuantity > 0 || x.isWhiteCell);
  }

  get palettePrice() {
    return this.sizes[0].discountedUnitPrice;
  }
}

export class ProductSize {
  id: number;
  group: number;
  name: string;
  availableQuantity: number;
  variantId: number;
  paletteId: number;
  orderItemId: number;
  value: FormControl;
  unitPriceWholesale: number;
  retailUnitPrice: number;
  discountedUnitPrice: number;
  automaticDiscounts: AutomaticDiscountGetDto[];
  requestedDeliveryDate: string;
  customDeliveryDate: string;
  quantity: number;
  cacheQty?: number;
  storeChannelDiscount: number;
  residualQty: number;
  isWhiteCell: boolean;
  sizeOrder?: number;
  channelSupportsForcedQuantityIncrement: boolean;
  quantityBuyIncrement: number;
  quantityMinimumPerOrder: number;

  constructor(s: Partial<ProductSize>) {
    if (s) { Object.assign(this, s); }
    if (s.automaticDiscounts) { this.automaticDiscounts = s.automaticDiscounts.map(x => new AutomaticDiscountGetDto(x)); }

    this.cacheQty = UtilityFunctions.DeepClone(this.quantity);
    this.value = new FormControl(s?.value?.value, { updateOn: 'blur' });
    this.setResidualQuantity();
    this.value.valueChanges.pipe(
      distinctUntilChanged()
    ).subscribe(val => {
      let variantValue: number | string = val;
      if (val) {
        if (this.channelSupportsForcedQuantityIncrement)
          variantValue = UtilityFunctions.getValueForcedQuantityIncrement(val, this.quantityBuyIncrement, this.availableQuantity);
        variantValue = this.isWhiteCell ? Math.max(Math.round(+variantValue), 0) : Math.max(Math.min(Math.round(+variantValue), this.availableQuantity), 0);
      } else {
        variantValue = null;
      }
      this.value.setValue(variantValue, { emitViewToModelChange: true });
    });
  }

  setWhiteCell(value: boolean): void {
    this.isWhiteCell = value;
  }

  setAvailableQuantity(value: number) {
    this.availableQuantity = value ?? 0;
    this.setResidualQuantity();
  }

  increase() {
    let qty = 0;
    if (this.isWhiteCell) {
      qty = +this.value.value + 1;
    } else if (this.channelSupportsForcedQuantityIncrement) {
      qty = +this.value.value + this.quantityBuyIncrement;
    } else {
      qty = Math.min(this.availableQuantity, this.value.value + 1);
    }
    this.value.setValue(qty);
  }

  decrease() {
    let qty = 0;
    if (this.isWhiteCell) {
      qty = this.value.value - 1;
    } else if (this.channelSupportsForcedQuantityIncrement) {
      qty = this.value.value - this.quantityBuyIncrement;
    } else {
      qty = Math.max(this.value.value - 1, 0);
    }
    this.value.setValue(qty);
  }

  clear() {
    this.value.setValue('');
  }

  setResidualQuantity() {
    this.residualQty = this.isWhiteCell ? Infinity : this.availableQuantity - (this.quantity || 0);
    if (!this.value) this.value = new FormControl(null, {
      validators: [Validators.max((this.residualQty > 0 ? this.residualQty : 0))],
      updateOn: 'blur'
    });
    else this.value.setValidators(Validators.max(this.residualQty > 0 ? this.residualQty : 0));
  }

  get totalPrice() {
    return this.value?.value * this.discountedUnitPrice;
  }
}


export class ProductColorRow {
  code: string;
  paletteId: number;
  description: string;
  mediaSrc: string;
  wholesalePrice?: string;
  retailPrice?: string;
  priceDetails?: ProductPricesSummary;
  sizes: { [key: number]: FullProductSizeCell; };
  stockLimit?: number;
  currentLimit?: number;
  quantityBuyIncrement: number;
  quantityMinimumPerOrder: number;
  isError: boolean;
  productTitle: string;
  productCode: string;
  productId: number;
  sizesPrices: PriceSizeVM[];
  isVisible?: boolean;
  hasValidInputValue: boolean;
  minQtyError: boolean;
  selected?: boolean;
  exCode?: number;
  constructor(init?: Partial<ProductColorRow>) {
    Object.assign(this, init);
    if (!this.sizes) {
      this.sizes = {};
    }
  }

  get totalPcs() {
    return Object.keys(this.sizes || {}).reduce((sum, k) => sum + (this.sizes[+k].quantity || 0), 0);
  }

  get totalPrice() {
    return Object.keys(this.sizes || {}).reduce((sum, k) => sum + (this.sizes[+k].discountedUnitPrice * this.sizes[+k].quantity || 0), 0);
  }

  get isAvailableSizes() {
    return Object.keys(this.sizes || {}).some(k => this.sizes[+k].availableQuantity > 0 || this.sizes[+k].isWhiteCell);;
  }
}

export class PriceSizeVM {
  sizeId: number;
  sizeName: string;
  sizeOrder: number;
  sizeGroupId: SizeGroupTypeEnum;
  retailPrice: number;
  wholesalePrice: number;
  discountedPrice: number;
  discountedPercentage: number;

  constructor(init?: PriceSizeVM) {
    Object.assign(this, init);
  }
}

export class ProductSizeCell {
  sizeId: number;
  sizeOrder: number;
  SKUCode: string;
  group: SizeGroupTypeEnum;
  sizeName: string;
  availableQuantity: number;
  variantId: number;
  paletteId: number;
  unitPriceWholesale: number;
  retailUnitPrice: number;
  discountedUnitPrice: number;
  automaticDiscounts: AutomaticDiscountGetDto[];
  storeChannelDiscount: number;
  channelSupportsForcedQuantityIncrement: boolean;
  quantityBuyIncrement: number;
  quantityMinimumPerOrder: number;
  constructor(init?: Partial<ProductSizeCell>) {
    Object.assign(this, init);
  }
}

export class FullProductSizeCell extends ProductSizeCell {
  isWhiteCell: boolean;
  isCartMode: boolean;
  quantity: number;
  residualQty: number;
  inStockQty: number;
  inputValue: number;
  customDeliveryId?: number;

  constructor(s?: Partial<FullProductSizeCell>) {
    super(s);
    if (s) { Object.assign(this, s); }
    if (s.automaticDiscounts) { this.automaticDiscounts = s.automaticDiscounts.map(x => new AutomaticDiscountGetDto(x)); }

    this.init(this.availableQuantity, this.quantity);
  }

  setInputValue(value: number) {
    this.inputValue = value || 0;
    this.checkAndSetInputValue();
  }

  checkAndSetInputValue() {
    let value = this.inputValue || 0;
    if (this.channelSupportsForcedQuantityIncrement && !!value) {
      const forcedQty = UtilityFunctions.getValueForcedQuantityIncrement(value, this.quantityBuyIncrement, this.availableQuantity);
      value = forcedQty;
    }
    value = this.isWhiteCell ?
      Math.max(Math.round(value), 0) :
      Math.max(Math.min(Math.round(value), this.isCartMode ? this.availableQuantity : this.residualQty), 0);
    this.inputValue = value || null;
  }

  init(availableQty: number, cartQty: number) {
    this.quantity = cartQty || 0;
    this.availableQuantity = availableQty || 0;
    this.setResidualQuantity();
    this.isWhiteCell = availableQty === Infinity;
    this.inputValue = 0;
    this.checkAndSetInputValue();
  }

  private setResidualQuantity(quantity: number = this.quantity) {
    let res = this.isWhiteCell ? Infinity : this.availableQuantity - (quantity || 0) >= 0 ? this.availableQuantity - (quantity || 0) : 0;
    if (this.channelSupportsForcedQuantityIncrement && this.residualQty < this.quantityBuyIncrement) res = 0;
    this.residualQty = res < 0 ? 0 : res;
  }
}

